import '../../sass/blocks/colour-list.scss';

import { toggleExpandable } from '../common/expandable';
import cachios from 'cachios';
import { openModal } from '../common/modals';

const noMotionPreference = window.matchMedia('(prefers-reduced-motion: no-preference)');

(() => {
    const $colourLists = document.querySelectorAll('.colour-list');

    if (!$colourLists) return;

    $colourLists.forEach($colourList => {
        const $colourListSwatchBtns = $colourList.querySelectorAll('.colour-list-swatch__btn');
        const $colourListModal = $colourList.querySelector('.colour-list-modal');
        const $colourListModalContentInner = $colourList.querySelector('.colour-list-modal__content-inner');

        const $howButton = $colourList.querySelector('.colour-list-top__how-button');
        const $howContent = $colourList.querySelector('.colour-list-top__how-content');

        const initSwatchSwiper = () => {
            const $swatchSwiper = $colourList.querySelector('.colour-list-modal__swatch-swiper');
            const $addToCartForms = $colourList.querySelectorAll('.colour-list-add-to-cart');
    
            if (!$swatchSwiper) return;

            const swatchSwiper = new Swiper($swatchSwiper, {
                effect: 'fade',
                fadeEffect: {
                    crossFade: false
                },
                speed: noMotionPreference.matches ? 300 : 0,
            });

            if (swatchSwiper && $addToCartForms) {
                $addToCartForms.forEach($addToCartForm => {
                    const { swatchIndex } = $addToCartForm?.dataset;

                    $addToCartForm.addEventListener('mouseover', () => {
                        swatchSwiper.slideTo(swatchIndex);

                        const $aactiveAddToCartForms = $colourList.querySelectorAll('.colour-list-add-to-cart--active');

                        if ($aactiveAddToCartForms) {
                            $aactiveAddToCartForms.forEach($aactiveAddToCartForm => {
                                $aactiveAddToCartForm.classList.remove('colour-list-add-to-cart--active');
                            })
                        }

                        $addToCartForm.classList.add('colour-list-add-to-cart--active');
                    });
                });
            }
        }

        const initSwatchBtns = () => {
            if (!$colourListSwatchBtns) return;

            $colourListSwatchBtns.forEach($colourListSwatchBtn => {
                $colourListSwatchBtn.addEventListener('click', e => {
                    e.preventDefault();

                    const { nonce, productRangeId, colourId, colourNumber } = $colourListSwatchBtn?.dataset;
                    
                    cachios.get(GLOBALS.AJAX_URL, {
                        params: {
                            action: 'armourcoat_theme_ajax_get_colour_list_modal_content', 
                            nonce,
                            product_range_id: productRangeId,
                            colour_id: colourId,
                            colour_number: colourNumber,
                        }
                    }).then(response => {
                        if ($colourListModalContentInner && response?.data?.data?.modal_content) {
                            $colourListModalContentInner.innerHTML = response.data.data.modal_content;
                        }

                        initSwatchSwiper();
                        openModal($colourListModal);

                        if ($colourListSwatchBtn?.href) {
                            window.history.replaceState('', '', $colourListSwatchBtn.href);
                        }
                    });
                });
            });
        };

        const initModal = () => {
            $colourListModal.addEventListener('modalclose', () => {
                const url = new URL(window.location.href);
                const params = new URLSearchParams(url.search);

                params.delete('colour');

                window.history.replaceState(null, document.title, url.pathname + (params.toString() ? '?' + params.toString() : ''));
            });
        };

        const initHow = () => {
            if (!$howButton || !$howContent) return;

            $howButton.addEventListener('click', () => {
                toggleExpandable($howContent);
            });
        };

        initSwatchBtns();
        initModal();
        initHow();
        initSwatchSwiper();
    });
})();
